/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CognitoStrictHttpResponse } from '../../cognito-strict-http-response';
import { CognitoRequestBuilder } from '../../cognito-request-builder';

import { CognitoCognitoUserResponseDto } from '../../models/cognito-cognito-user-response-dto';

export interface CognitoControllerGetUser$Params {

/**
 * The ID (sub) of the user
 */
  id: string;
}

export function cognitoControllerGetUser(http: HttpClient, rootUrl: string, params: CognitoControllerGetUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>> {
  const rb = new CognitoRequestBuilder(rootUrl, cognitoControllerGetUser.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>;
    })
  );
}

cognitoControllerGetUser.PATH = '/o2-cognito/cognito/users/{id}';
